import React, { useEffect, useState } from "react";
import { AprobarSolicitudesHEDTO } from "../Revisar Solicitudes Horas Extras/typesAprobarSolicitudHE";
import { Col, Row, Table } from "react-bootstrap";
import { PaginationLink, PaginationItem, Pagination, Input, Label } from "reactstrap";
import { ObtenerFechaFromIsoFormat } from "functions/DatesFunctions";
import { ReactComponent as IconReversar } from "../../../../assets/icons/HorasExtras/Reversar.svg";
import { ReversarSolicitudes } from "./FunctionsHistorialSolicitudes";
import { showAlert } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import Swal from "sweetalert2";
import ModalCargando from "components/Varios/ModalCargando";
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import { GetDocumentVistaPrevia2 } from "helpers/files";
import { VistaPreviaSolicitudHEIngresada } from "components/UsuarioGeneral/HorasExtras/SolicitudPagoHE/FunctionsSolicitudPagoHE";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";

type PropsHistorialSolicitudes = {
    contenido: AprobarSolicitudesHEDTO[],
    mes: number,
    actualizar: () => void,
}

export default function TableHistorialSolicitudes(props: PropsHistorialSolicitudes) {
    const { contenido, mes } = props;

    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);
    const [loading, setloading] = useState<boolean>(false)

    const [urlDocMarcaciones, seturlDocMarcaciones] = useState('');
    const [urlDocSolicitudHE, seturlDocSolicitudHE] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const [fechaHoy, setfechaHoy] = useState<number | null>(null);
    const sinReverso = ["AC", "AF", "PD"];
    const ReversoMAsivo = ["FT", "FJ", "FF", "FA"];

    const [loadingHojaMarcacion, setloadingHojaMarcacion] = useState<boolean>(false)
    const [urlHojaMarcacionVP, seturlHojaMarcacionVP] = useState<string>("")
    const [urlDocumentoVP, seturlDocumentoVP] = useState<string>("")


    useEffect(() => {
        handleSort("nombres");
        const fecha = new Date();
        setfechaHoy(fecha.getMonth() + 1)
    }, [])

    async function Reversar(solicitudes: AprobarSolicitudesHEDTO[] | null) {
        if (solicitudes) {


            var texto = `<div class="custom-modal-content">
                            <p>¿Esta seguro que desea Reversar esta solicitud?</p>
                        </div>`;

            if (solicitudes[0].ingresoManual === "S") {
                texto = `<div class="custom-modal-content">
                            <strong>
                                Recuerde que la solicitud fue ingresada manualmente
                            <strong/>
                            <p>¿Esta seguro que desea Anular esta solicitud?</p>
                        </div>`;
            }

            const result = await Swal.fire({
                html: texto,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn-cancelar',
                    confirmButton: 'btn-aceptar',
                    popup: 'custom-popup'
                },
            });

            if (result.isConfirmed) {
                setloading(true);
                const solicitudesReversadas = await ReversarSolicitudes(solicitudes);
                if (solicitudesReversadas.status == 200) {
                    showAlert("Se ha reversado la solicitud correctamente", true);
                    props.actualizar();
                }
                else {
                    showAlert(typeof solicitudesReversadas.errorMessage === 'string' ? solicitudesReversadas.errorMessage : 'Ha ocurrido un inconveniente al reversar la solicitud', false);
                }
                setloading(false);
            } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
                console.log("Se negó la acción.");
            } else {
                console.log("El modal fue cerrado sin realizar una acción.");
                return;
            }

        }
    }

    async function OnClickDocumentoHojaMarcacion(refArchivo: string) {
        if (refArchivo) {
            setloadingHojaMarcacion(true)
            const url = await GetDocumentVistaPrevia2(refArchivo)
            if (url) {
                seturlHojaMarcacionVP(url)
            }
            setloadingHojaMarcacion(false)
        }
        else {
            showAlert("Referencia de archivo no válida", false)
        }
    }

    async function OnClickDocumento(historia: AprobarSolicitudesHEDTO) {
        if (historia.refArchivo) {
            setloading(true)
            const url = await GetDocumentVistaPrevia2(historia.refArchivo)
            if (url) {
                seturlDocumentoVP(url)
            }
            setloading(false)
        }
        else {
            await GenerarVistaPreviaSolicitudHE(historia.idSolicitud)
        }
    }

    async function GenerarVistaPreviaSolicitudHE(idSolicitudHE: number) {
        setloading(true)

        const respuestaVistaPrevia = await VistaPreviaSolicitudHEIngresada(idSolicitudHE);

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
            seturlDocumentoVP(respuestaVistaPrevia.dataResponse)
        }
        else {
            showAlert("No es posible cargar la vista previa del documento", false);
        }


        setloading(false)
    }


    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }

                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }

                return 0;


            });
            return sortedData;
        }

    };
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };
    //filtrado para el buscador
    const filteredSolicitudes = (contenido && contenido.length > 0) ? contenido.filter(solic =>
    (solic.nombres.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.regimen.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.identificacion.toLowerCase().includes(searchTerm.toLowerCase()))
    ) : [];
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    //presenta las filas asignadas
    const sortedSolicitudes = applySorting(filteredSolicitudes);
    let currentRows = sortedSolicitudes.slice(indexOfFirstRow, indexOfLastRow);

    //obtiene el numero de paginas segun la cantidad de datos
    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(sortedSolicitudes.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    return (
        <React.Fragment>
            <Row className="d-flex justify-content-end">
                <Col md="3">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    />
                </Col>
            </Row>
            {currentRows.length < 1 && (
                <span> No se encontraron datos </span>
            )}
            {currentRows.length > 0 && (
                <div className="table-responsive containerTablaHistorial" >
                    <Table className="table_planificacion_he table-bordered">
                        <thead className="cabeceras_tabla_servidores_act_he">
                            <tr>
                                <th colSpan={1} align={"center"}> # </th>
                                <th colSpan={1} align={"left"} onClick={() => handleSort("fechaSolicitud")}> Fecha <br /> Solic.</th>
                                <th colSpan={1} align={"left"} onClick={() => handleSort("mesDescripcion")}> Mes <br /> Solic.</th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("identificacion")}> Cédula </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("nombres")}> Nombres </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("unidad")}> Unidad </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("regimen")}> Régimen </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("rmu")}> RMU <br /> vigente </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("heSumplementarias")}> Total Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("heExtraordinaria")}> Total Horas <br /> Extraord. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("tHorasExtras")}> Total Horas <br /> Extras </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vHeSuplementarias")}> Valor Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vHeExtraordinaria")}> Valor Horas <br /> Extraord. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("tvHorasExtras")}> Valor a Recibir </th>
                                <th colSpan={1} align={"center"} > Documentos </th>
                                {fechaHoy == mes && currentRows[0].estado.trim() != "NT" && <th colSpan={1} align={"center"} > Reversar </th>}
                                <th colSpan={1} align={"center"} onClick={() => handleSort("ingresoManual")}> </th>
                            </tr>
                        </thead>
                        <tbody className="tbodyAprobacionNominaTH">
                            {currentRows.map((ic, i) => {
                                const globalIndex = indexOfFirstRow + i + 1
                                return (
                                    <React.Fragment key={i}>
                                        <tr className=''>
                                            <td className="centrado"> {globalIndex} </td>
                                            <td className="centrado"> {ObtenerFechaFromIsoFormat(ic.fechaSolicitud)} </td>
                                            <td className="centrado"> {ic.mesDescripcion} </td>
                                            <td className="centrado"> {ic.identificacion} </td>
                                            <td className="izquierda"> {ic.nombres} </td>
                                            <td className="centrado"> {ic.unidad} </td>
                                            <td className="centrado"> {ic.regimen} </td>
                                            <td className="centrado"> {ic.rmu.toFixed(2)} </td>
                                            <td className="centrado"> {ic.heSumplementarias} </td>
                                            <td className="centrado"> {ic.heExtraordinaria} </td>
                                            <td className="centrado"> {ic.tHorasExtras} </td>
                                            <td className="centrado"> {ic.vHeSuplementarias?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.vHeExtraordinaria?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.tvHorasExtras?.toFixed(2)} </td>
                                            <td>
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <img
                                                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                    className="iconPDF"
                                                    alt={`Hoja de marcaciones del mes de ${ic.mesDescripcion}`}
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title={`Hoja de marcaciones del mes de ${ic.mesDescripcion}`}
                                                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                    onClick={() => { OnClickDocumentoHojaMarcacion(ic.refArchivoMarcacion) }}
                                                />

                                                <img
                                                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                    className="iconPDF"
                                                    alt={`Formulario de Horas Extras del mes de ${ic.mesDescripcion}`}
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title={`Formulario de Horas Extras del mes de ${ic.mesDescripcion}`}
                                                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                    onClick={() => { OnClickDocumento(ic) }}
                                                />
                                            </div>
                                        </td>
                                        {sinReverso.includes(ic.estado.trim()) && fechaHoy == mes &&
                                            <td className="centrado"> No puede Reversar </td>
                                        }
                                        {ReversoMAsivo.includes(ic.estado.trim()) && fechaHoy == mes &&
                                            <td className="centrado"> No puede Reversar Individualmente</td>
                                        }
                                        {ic.estado.trim() == "FN" && fechaHoy == mes &&
                                            <td className="centrado">
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                                                    <IconReversar
                                                        className={"icono-red"}
                                                        onClick={() => {
                                                            Reversar([ic]);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        }
                                        <td className="centrado"> {ic.ingresoManual === "S" ? "M" : ""} </td>
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        </tbody>
                    </Table>
                </div >
            )}


            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>
            <ModalCargando
                show={loading != false}
                onClose={() => setloading(false)}
                textoCargando='Reversando'
                size='md'
            />
            <ModalVistaPreviaDocumentos
                show={loading || urlDocumentoVP !== ""}
                cargandoDatos={loading}
                size='xl'
                tituloModal='Solicitud de Horas Extras'
                onClose={() => seturlDocumentoVP("")}
                urlArchivo={urlDocumentoVP}
                allHeight={true}
            />
            <ModalVistaPreviaDocumentos
                show={loadingHojaMarcacion || urlHojaMarcacionVP !== ""}
                cargandoDatos={loading}
                size='xl'
                tituloModal='Hoja Marcaciones'
                onClose={() => seturlHojaMarcacionVP("")}
                urlArchivo={urlHojaMarcacionVP}
                allHeight={true}
            />
        </React.Fragment>
    )
}